import React, { useState, useContext } from 'react';
import { Navbar, NavbarBrand, Nav, NavItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

// local imports
import Logo from '../../assets/UW_Horizontal_Logo_Full.png'

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';
import { PsychometricContext } from "../../contexts/PsychometricContext";

const PsychometricOrganizationNavbar = (props) => {

    // states
    const [isOpenDropdown, setIsOpenDropdown] = useState(false);
    const { signedOrganization, setSignedOrganization, setSignedEmail, setSignedPassword } = useContext(PsychometricContext); 
    const history = useHistory();

    // contexts
    const { fontFamily } = useContext(ThemeContext);
    const { user } = useContext(AuthContext);

    // utility functions
    const toggleDropdown = () => setIsOpenDropdown(!isOpenDropdown);

    // logout function
    const handleLogout = () => {
        setSignedEmail("");
        setSignedPassword("");
        setSignedOrganization("");
        history.push('/psychometricSignIn'); 
    };

    return (
        <div>
            <Navbar id="psychometric-organization-navbar" color="white" light expand="md" style={{ fontFamily: fontFamily.primary }}>
                <NavbarBrand className="p-0" href="/">
                    <img id="brand-logo" style={{ maxWidth: "160px", height: "auto", border: "none", margin: "0" }} src={Logo} alt="Umang Logo" />
                </NavbarBrand>
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <Dropdown id="organization-menu" isOpen={isOpenDropdown} toggle={toggleDropdown}>
                            <DropdownToggle nav caret>
                                Organization
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem tag={Link} to="/psychometricOrganizationHome">Org Profile</DropdownItem>
                                <DropdownItem tag={Link} to="/psychometricOrganizationCandidates">Manage Candidates</DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </NavItem>
                </Nav>
            </Navbar>
        </div>
    );
}

export default PsychometricOrganizationNavbar;
